export default "__VITE_ASSET__B4ib_HlU__"